export const Status = {
  TODO: 'TODO',
  IN_PROGRESS: 'IN_PROGRESS',
  BLOCKED: 'BLOCKED',
  DONE: 'DONE'
}

export const Urgency = {
  NORMAL: 'NORMAL',
  IMPORTANT: 'IMPORTANT',
  CRITICAL: 'CRITICAL'
}

export const LocationType = {
  LOCATIF: 'LOCATIF',
  COMMON_ZONE: 'COMMON_ZONE',
  EQUIPMENT: 'EQUIPMENT'
}
